<template>
  <div class="pa-5 d-flex flex-column align-center">
    <v-icon color="primary" size="70">fal fa-circle-check</v-icon>
    <div class="mt-4 subtitle-1" style="color: rgb(43, 65, 84)">{{text}}</div>
  </div>
</template>
<script>

export default {
  name: 'CardInfo',
  components: {},
  props: {
    text: {type: String, default: ''}
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
  }
};
</script>